import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
    verifyPaymentLinkCode,
    processPaymentLinkPayment,
} from "../../services/payment-link.services";
import {
    IVerifyPaymentLinkCodePayload,
    IVerifyPaymentLinkCodeResponse,
    IProcessPaymentLinkPaymentPayload,
} from "../../types/payment-link.types";
import { IApiResponse } from "../../../../utils/types/api-response";

export function useVerifyPaymentLinkCode() {
    return useMutation<
        IApiResponse<IVerifyPaymentLinkCodeResponse>,
        AxiosError<IApiResponse<IVerifyPaymentLinkCodeResponse>>,
        IVerifyPaymentLinkCodePayload
    >({
        mutationKey: ["verify-payment-link-code"],
        mutationFn: (payload: IVerifyPaymentLinkCodePayload) =>
            verifyPaymentLinkCode(payload),
    });
}

export function useProcessPaymentLinkPayment() {
    return useMutation<
        IApiResponse<{ message: string }>,
        AxiosError<IApiResponse<{ message: string }>>,
        IProcessPaymentLinkPaymentPayload
    >({
        mutationKey: ["process-payment-link-payment"],
        mutationFn: (payload: IProcessPaymentLinkPaymentPayload) =>
            processPaymentLinkPayment(payload),
    });
}
